import xhr from '~/xhr';
/* eslint-disable */
// 适用于不需要判断code的接口
const doGet = (url, args) =>
  xhr
    .get(url, args)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
    });

const getMock = function() {
  return new Promise((res, rej) => {
    res({
      pcBanner: {
        // en: {
        //   text1: 'BIGO Live is now on Discord!',
        //   text2:
        //     'Join the server today for the latest news, updates and giveaways. ',
        //   btnText: 'Join',
        //   link: 'https://bigo.onelink.me/1168916328/JeesieJ',
        //   isEN: true,
        //   inRoom: false // 是否在room中展示
        // },
        pl: {
          text1: 'Dołącz do BIGO LIVE jako agent lub broadcaster!',
          text2:
            'Jesteś zainteresowany rozpoczęciem własnej kariery w BIGO? Wypełnij formularz!',
          btnText: 'Aplikuj teraz',
          link: 'https://forms.gle/F2Bw8E7QHALKvCna9',
          inRoom: true
        },
        ro: {
          text1: 'Alăturați-vă BIGO LIVE ca agent sau broadcaster!',
          text2:
            'Ești interesat să îți începi o noua carieră în BIGO? Completază acest formular!',
          btnText: 'Aplică acum',
          link: 'https://forms.gle/cDKPc2Ubit9mftL19',
          inRoom: true
        },
        tr: {
          text1: "Bigo'nun resmi yayıncı/ajansı olmak için fırsatı kaçırmayın!",
          text2:
            'Yeni haberler, güncellemeler ve politikalar için Bigo’ya bugün katılın',
          btnText: 'katıl',
          link:
            'https://docs.google.com/forms/d/e/1FAIpQLSeXk5fk8LzB0FaAp527pyA7FyudGjnICI1YjuTEzyPtZHFlrg/viewform',
          inRoom: true
        },
        fr: {
          text1: 'Bigo recherche de nouveaux broadcasters talentueux!',
          text2: `Vous êtes beau/belle? Vous savez chanter? Vous avez un talent spécial? Venez montrer aux autres et gagner de l'argent.`,
          btnText: 'Inscrire',
          link: 'https://forms.gle/ZYxhDmtKpk91DC578',
          inRoom: true
        },
        th: {
          text1: 'BIGO เปิดรับสมัคร Official Agency',
          text2: `งานชิวทำที่ไหนก็ได้ รายได้สูงสุด "หลักล้าน"!! รีบมาสมัครสังกัดของบีโก้กัน`,
          btnText: 'สมัครทันที',
          link: 'https://forms.gle/dscFTcakovorGPJA8',
          inRoom: true
        },
        it: {
          text1: 'Come diventare Agenti e Broadcaster su BIGO LIVE?',
          text2: `Adesso comincia anche tu a guadagnare soldi e conoscere nuovi amici!`,
          btnText: 'Maggior info',
          link:
            'https://docs.google.com/forms/d/e/1FAIpQLSdiufVUJwQUCdFyGtUPE_IE6P6_PshOsvaJOuUB5w-VwUNgrg/viewform',
          inRoom: true
        },
        id: {
          text1: 'Daftar Agency di BIGO LIVE dan dapatkan banyak keuntungan!',
          text2: `SELAMAT!! Kamu selangkah lebih dekat untuk menjadi Official AGENCY BIGO LIVE`,
          btnText: 'Daftar',
          link: 'https://forms.gle/ihiE9t48Nhvi3NdR7',
          inRoom: true
        }
      },
      mobileBanner: [
        {
          pics: {
            default:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/en.jpeg',
            ar:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/ar.jpeg',
            de:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/de.jpeg',
            en:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/en.jpeg',
            es:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/es.jpeg',
            fr:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/fr.jpeg',
            id:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/id.jpeg',
            it:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/it.jpeg',
            ja:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/ja.jpeg',
            km:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/km.jpeg',
            ko:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/ko.jpeg',
            mm:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/mm.jpeg',
            ms:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/ms.jpeg',
            nl:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/nl.jpeg',
            pl:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/pl.jpeg',
            pt:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/pt.jpeg',
            ro:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/ro.jpeg',
            ru:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/ru.jpeg',
            se:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/se.jpeg',
            th:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/th.jpeg',
            tr:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/tr.jpeg',
            tw:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/tw.jpeg',
            vn:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/vn.jpeg',
            cn:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/niandu/tw.jpeg'
          },
          link:
            'https://bigolive.onelink.me/sG8X?pid=YouTube&c=YouTube&is_retargeting=true',
          actid: '16907-8058'
        },
        {
          pics: {
            default:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/en.png',
            en:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/en.png',
            it:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/it.png',
            hi:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/hi.png',
            id:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/id.png',
            cn:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/cn.png',
            ar:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/ar.png',
            de:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/de.png',
            ru:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/ru.png',
            tw:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/tw.png',
            ms:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/ms.png',
            ko:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/ko.png',
            pt:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/pt.png',
            ja:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/ja.png',
            fr:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/fr.png',
            th:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/th.png',
            tr:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/th.png',
            es:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/es.png',
            vi:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202/vi.png'
          },
          link:
            'https://bigo.onelink.me/sG8X?pid=YouTube&c=family&is_retargeting=true&af_ios_url=bigolive%3A%2F%2Fweb%3Furl%3Dhttps%253a%252f%252factivity.bigo.tv%252flive%252fact%252fact_14587&af_android_url=bigolive%3A%2F%2Fweb%3Furl%3Dhttps%253a%252f%252factivity.bigo.tv%252flive%252fact%252fact_14587',
          actid: '14587'
        },
        {
          pics: {
            default:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/en.png',
            ar:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/ar.png',
            de:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/de.png',
            ru:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/ru.png',
            ko:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/ko.png',
            fr:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/fr.png',
            tw:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/tw.png',
            km:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/km.png',
            ms:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/ms.png',
            pt:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/pt.png',
            th:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/th.png',
            tr:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/tr.png',
            ja:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/ja.png',
            es:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/es.png',
            id:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/id.png',
            hi:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/hi.png',
            vi:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/vi.png',
            en:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/en.png',
            cn:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/20201202-huangshi/cn.png'
          },
          link:
            'https://bigo.onelink.me/sG8X?pid=YouTube&c=RoyalPK&is_retargeting=true&af_ios_url=bigolive%3A%2F%2Fweb%3Furl%3Dhttps%253a%252f%252factivity.bigo.tv%252flive%252fact%252fact_13724%252findex.html&af_android_url=bigolive%3A%2F%2Fweb%3Furl%3Dhttps%253a%252f%252factivity.bigo.tv%252flive%252fact%252fact_13724%252findex.html',
          actid: '13724'
        }
      ],
      mobileBGs: {
        default:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/EN.png',
        ar:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/AR.png',
        br:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/BR.png',
        de:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/DE.png',
        en:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/EN.png',
        es:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/ES.png',
        fr:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/FR.png',
        id:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/ID.png',
        it:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/IT.png',
        ja:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/JA.png',
        km:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/KM.png',
        ko:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/KO.png',
        mm:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/MM.png',
        ms:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/MS.png',
        nl:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/NL.png',
        pl:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/PL.png',
        ro:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/RO.png',
        ru:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/RU.png',
        se:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/SE.png',
        th:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/TH.png',
        tr:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/TR.png',
        tw:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/TW.png',
        vi:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/VI.png',
        cn:
          'https://static-web.hzmk.site/as/bigo-static/act_30282/banners/bg/TW.png'
      },
      topDownloadLink:
        'https://bigolive.onelink.me/sG8X?pid=YouTube&c=YouTube&is_retargeting=true',
      videoList: [
        {
          video:
            'https://static-web.hzmk.site/as/bigo-static/act_30282/video/dianliang.mp4',
          poster:
            'https://static-web.hzmk.site/as/bigo-static/act_30282/video/dianliang.jpg'
        },
        {
          video:
            'https://static-web.hzmk.site/as/bigo-static/act_30282/video/yugao.mp4',
          poster:
            'https://static-web.hzmk.site/as/bigo-static/act_30282/video/yugao.jpg'
        },
        {
          video:
            'https://static-web.hzmk.site/as/bigo-static/act_30282/video/huigu.mp4',
          poster:
            'https://static-web.hzmk.site/as/bigo-static/act_30282/video/huigu.jpg'
        }
      ],
      mobileSwiper: {
        en: [
          // {
          //   img:
          //     'https://static-web.hzmk.site/as/bigo-static/act_30282/jessic/750x210.jpg',
          //   link: 'https://bigo.onelink.me/1168916328/JeesieJ'
          // },
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/en-news-blog.jpg',
            link: 'https://blog.bigo.tv/en/'
          }
        ],
        ar: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/ar-news-blog.jpg',
            link: 'https://blog.bigo.tv/'
          }
        ],
        cn: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/cn-news-blog.jpg',
            link: 'https://blog.bigo.tv/tw/'
          }
        ],
        de: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/de-news-blog.jpg',
            link: 'https://blog.bigo.tv/de/'
          }
        ],
        ko: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/ko-news-blog.jpg',
            link: 'https://blog.bigo.tv/ko/'
          }
        ],
        ja: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/ja-news-blog.jpg',
            link: 'https://blog.bigo.tv/jp/'
          }
        ],
        tw: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/tw-news-blog.jpg',
            link: 'https://blog.bigo.tv/tw/'
          }
        ],
        vi: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/vi-news-blog.jpg',
            link: 'https://blog.bigo.tv/vi/'
          }
        ],
        ru: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/ru-news-blog.jpg',
            link: 'https://blog.bigo.tv/ru/'
          }
        ],
        th: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/th-news-blog.jpg',
            link: 'https://blog.bigo.tv/th/'
          }
        ],
        pt: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/pt-news-blog.jpg',
            link: 'https://blog.bigo.tv/pt/'
          }
        ],
        es: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/es-news-blog.jpg',
            link: 'https://blog.bigo.tv/es/'
          }
        ],
        id: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/id-news-blog.jpg',
            link: 'https://blog.bigo.tv/id/'
          }
        ],
        tr: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/tr-news-blog.jpg',
            link: 'https://blog.bigo.tv/tr/'
          }
        ],
        ms: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/ms-news-blog.jpg',
            link: 'https://blog.bigo.tv/ms/'
          }
        ],
        mm: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/mm-news-blog.jpg',
            link: 'https://blog.bigo.tv/'
          }
        ],
        nl: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/nl-news-blog.jpg',
            link: 'https://blog.bigo.tv/'
          }
        ],
        ro: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/ro-news-blog.jpg',
            link: 'https://blog.bigo.tv/'
          }
        ],
        se: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/se-news-blog.jpg',
            link: 'https://blog.bigo.tv/'
          }
        ],
        default: [
          {
            img:
              'https://static-web.hzmk.site/as/bigo-static/act_30282/swiper/en-news-blog.jpg',
            link: 'https://blog.bigo.tv/'
          }
        ]
      }
    });
  });
};

const env = process.env.NUXT_ENV_MODE;
const urlMap = {
  dev: 'https://gray-web-gateway.bigo.sg/adverthomepage',
  // gray: 'https://gray-web-gateway.bigo.sg/adverthomepage',
  gray: 'https://gray-web-gateway.bigo.sg/adverthomepage',
  prod: 'https://ta.cubetvgame.com/adverthomepage'
};
const BASE_URL = `${urlMap[env]}/room/`;

export default {
  getRoomList: () => doGet(`${BASE_URL}getRoomList`),
  getRoomMessage: (uid) => doGet(`${BASE_URL}getRoomMessage?uid=${uid}`),
  getAdBanner: () => {
    return new Promise((res, rej) => {
      const t = +new Date();
      const urlMap = {
        dev: `https://static-web.hzmk.site/as/common-static/pear/prod/gray-10000000955.json?t=${t}`,
        test: `https://static-web.hzmk.site/as/common-static/pear/prod/gray-10000000955.json?t=${t}`,
        gray: `https://static-web.hzmk.site/as/common-static/pear/prod/gray-10000000955.json?t=${t}`,
        prod: `https://static-web.hzmk.site/as/common-static/pear/prod/10000000955.json?t=${t}`
      };
      const xhr2 = new XMLHttpRequest();
      xhr2.onreadystatechange = function() {
        if (xhr2.readyState === 4) {
          if (xhr2.status === 200 && xhr2.responseText) {
            const d = JSON.parse(xhr2.responseText);
            if (d && d.value) {
              res(d.value);
            }
          } else {
            rej(xhr2.statusText);
            console.error('xhr error', xhr2.statusText);
          }
        }
      };

      xhr2.open('GET', urlMap[env], true);
      xhr2.send(null);
    });
  }
};
